import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Account } from '../../service/account.service';

@Component({
  selector: 'app-discord-account-info',
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './discord-account-info.component.html',
  styleUrl: './discord-account-info.component.less'
})
export class DiscordAccountInfoComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { user: Account }
  ) {}

}
